import isNotEmptyArray from '@travel/ui/utils/arrays';

export default () => {
  if (typeof window !== 'undefined' || process.env.NODE_ENV === 'development') {
    return console;
  } else {
    //CaaS-Log: /home/docker/logs/app
    const LOGS_FOLDER_PATH = process.env.LOG_PATH ? process.env.LOG_PATH : '/home/docker/.pm2/logs';

    const { createLogger, transports, format } = require('winston');
    const { join } = require('path');
    const { inspect } = require('util');
    const { timestamp, printf, combine } = format;

    let filename = 'app-error.log';
    let infoFileName = 'app-info.log';
    if (process.env.NODE_ENV === 'production' && !process.env.LOCAL_PROD) {
      filename = join(LOGS_FOLDER_PATH, '/app-error.log');
      infoFileName = join(LOGS_FOLDER_PATH, '/app-info.log');
    }
    let transportError;
    let infoTransport;
    if (!Boolean(process.env.ROTATING_LOGS)) {
      transportError = new transports.File({
        level: 'error',
        filename,
      });
      infoTransport = new transports.File({
        level: 'info',
        filename: infoFileName,
      });
    } else {
      const DailyRotateFile = require('winston-daily-rotate-file');
      transportError = new DailyRotateFile({
        level: 'error',
        dirname: LOGS_FOLDER_PATH,
        filename: 'app-error-%DATE%.log',
        datePattern: 'YYYY-MM-DD-HH',
        zippedArchive: true,
        maxSize: '20m',
        maxFiles: '10d',
      });
      infoTransport = new DailyRotateFile({
        level: 'info',
        dirname: LOGS_FOLDER_PATH,
        filename: 'app-info-%DATE%.log',
        datePattern: 'YYYY-MM-DD-HH',
        zippedArchive: true,
        maxSize: '20m',
        maxFiles: '10d',
      });
    }

    const formatLog = printf((info: any) => {
      const { message, timestamp, stack } = info;
      const args = info[Symbol.for('splat')];
      const logs = [timestamp];
      if (typeof message === 'object') {
        logs.push(inspect(message));
      } else {
        logs.push(message);
      }
      if (stack) {
        logs.push(stack);
      }
      if (isNotEmptyArray(args)) {
        args.forEach(arg => {
          if (typeof arg === 'object') {
            logs.push(inspect(arg));
          } else {
            logs.push(arg);
          }
        });
      }
      return logs.join(' ').replace(/\r?\n|\r/g, '');
    });

    const infoLogger = createLogger({
      format: combine(timestamp(), formatLog),
      transports: [infoTransport, new transports.Console()],
    });

    const errorLogger = createLogger({
      format: combine(timestamp(), formatLog),
      transports: [transportError, new transports.Console()],
    });

    return {
      info: (...params: any[]) => {
        return infoLogger.info(...params);
      },
      log: (...params: any[]) => {
        return infoLogger.info(...params);
      },
      error: (...params: any[]) => {
        return errorLogger.error(...params);
      },
      warn: (...params: []) => {
        return infoLogger.info(...params);
      },
    };
  }
};
